import { WebSocketTerminalPanel } from "@/infrastructure/rsocket/components/WebSocketTerminal.tsx";
import { SingleToggleGroup } from "@/shared/components";
import { ApiDomain, apiDomains } from "@/shared/utils";
import { useState } from "react";

export function WebsocketDebugging() {
    const [currentApiDomain, setCurrentApiDomain] = useState<ApiDomain>("regievoerder");
    const [unreadCount, setUnreadCount] = useState<number>(0);

    return (
        <>
            <h3 className="text-l text-content-emphasis">Websocket debugging ({unreadCount} ongelezen)</h3>
            <SingleToggleGroup
                options={apiDomains.map((a) => ({ value: a, label: a }))}
                value={currentApiDomain}
                onValueChange={setCurrentApiDomain}
            />
            <WebSocketTerminalPanel apiDomain={currentApiDomain} setUnreadCount={setUnreadCount} closeTerminal={() => {}} />
        </>
    );
}
